import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewChecked, AfterViewInit, } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { BySkill, SkillResponse, ByEmployee, Expertise, FilterResponse, DepartmentResult, CategoryResult } from "../api-interfaces";
import { SkillService } from "../services/skill.service";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { FlashService } from '../../flash/flash.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-filter',
  templateUrl: './admin-filter.component.html',
  styleUrls: ['./admin-filter.component.css']
})
export class AdminFilterComponent implements OnInit, AfterViewInit {

  @ViewChild('skillDrop') skillDrop: any;
  @ViewChild('categoryDrop') categoryDrop: any;
  @ViewChild('expertDrop') expertDrop: any;

  isSelected: boolean;
  isSelectedUser: boolean = false;
  isSelectedSkill: boolean = false;
  userDetail: BySkill[];
  departmentList: DepartmentResult[] = [];
  categoryList: CategoryResult[] = [];
  expertise: Expertise[] = [];
  skillList:  any[] = [];
  emp: Observable<ByEmployee>;
  private destroy: Subject<void> = new Subject<void>();
  noData: boolean;
  userloading: boolean;
  skillloading: boolean;
  searchResult: FilterResponse[] = [];
  filterResponse: FilterResponse[] = [];
  employee: FilterResponse[];
  filter = [];
  result;
  adminForm: FormGroup;
  filterData;
  mySettings: IMultiSelectSettings;
  selectedSkill: any;
  selectedCategories: any;
  selectExpertLevel: any;
  selectDepartment: any;
  selectEmployee: any;
  emptyArray = [];
  employeeClone: FilterResponse[];

  toggle: boolean;
  constructor(public skillService: SkillService,
     private router: Router,
     private spinnerService: Ng4LoadingSpinnerService,
     private route: ActivatedRoute,
     private formBuilder: FormBuilder,
     private changeDetector: ChangeDetectorRef,
     private flashService: FlashService

     ) {

   this.adminForm = this.formBuilder.group({
     filter_id: new FormControl('', Validators.required),
     employee_drop: new FormControl(''),
     department_drop: new FormControl(''),
     useremployee_drop: new FormControl(''),
     skill_drop: new FormControl(''),
     category_drop: new FormControl(''),
     expertlevel_drop: new FormControl(''),
   });

    this.emp = this.skillService.getEmployee();
    this.skillService.getExpertise().subscribe((res : any) => {
      //Removing unwanted default select level in API response.
      res.splice(res.indexOf(res.filter(res => res.expertise_weight === 0)[0]), 1);
      this.expertise = res.sort(((a,b) => parseInt(a.expertise_weight) - parseInt(b.expertise_weight)));;
      this.expertise.forEach((res, index) => {
        this.expertise[index].id = res.expertise_id;
        this.expertise[index].name = res.expertise_name;
      });
    })
  }

  ngOnInit() {
    this.mySettings = {
      enableSearch: true,
      checkedStyle: 'checkboxes',
      buttonClasses: 'btn btn-default btn-block',
      maxHeight: '200px',
      displayAllSelectedText: false,
      dynamicTitleMaxItems: 100
    };
  }


  async ngAfterViewInit() {
    let filterSkill  = this.route.snapshot.queryParamMap.get('filter')? this.route.snapshot.queryParamMap.get('filter'): 'by-user';
    let departmentId = this.route.snapshot.queryParamMap.get('departmentId');
    let categoryId   = this.route.snapshot.queryParamMap.get('categoryId');
    let skillId      = this.route.snapshot.queryParamMap.get('skillId');

    this.selectInput(filterSkill)

    await this.getDepartment([+departmentId], [+categoryId], [+skillId]);

    if (filterSkill == 'by-skill') {
      await this.searchSkillDetail([+departmentId], [+categoryId], [+skillId], '')
    }

    skillId ? this.selectedSkill = [+skillId] : this.selectedSkill;
    categoryId ? this.selectedCategories = [+categoryId] : this.selectedCategories;
    departmentId ? this.selectDepartment = [+departmentId] : this.selectDepartment;
  }

  selectDepartmentListner(event: number[]) {
    this.categoryList = [];
    if(!!event && event.length > 0) {
      // event.forEach(depId => {
      //   this.getCategoryByDepartmentId(depId)
      // });
      this.departmentListnerFilter(event);
    } else {
      this.adminForm.controls.category_drop.reset();
      this.adminForm.controls.skill_drop.reset();
    }
  }

  slecteSkilllistner(event) {
    this.changeDetector.detectChanges();
  }

  selectCategoryListner(event: any[]) {
    this.skillList = [];
    if(!!event && event.length > 0) {
      this.categoryListnerFilter(event);
    } else {
      this.adminForm.controls.skill_drop.reset();
    }
  }

  userSelectDepartmentListner(event: any[]) {
    this.employee = [];
    if(!!event && event.length > 0) {
      this.employeeListnerFilter(event);
    } else {
      this.employeeClone = [];
      this.adminForm.controls.useremployee_drop.reset();
    }
  }


  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  getFilter(){}

  selectInput(filterValue) {

    this.adminForm.controls.department_drop.reset();
    this.adminForm.controls.expertlevel_drop.reset();
    this.searchResult = [];
    this.filterResponse = [];
    this.isSelectedSkill = filterValue == "by-skill"? true: false;
    this.isSelectedUser = filterValue == "by-user"? true: false;

    this.adminForm.reset();
    this.adminForm.patchValue({
      'filter_id': filterValue
    });
  }

  searchUserDetail(id) {
    this.spinnerService.show();
    this.skillloading = false;
    this.userloading = true;
    this.skillService.searchByUser(id).subscribe(data => {
      this.spinnerService.hide();
      this.searchResult = data['data'];
      this.result = data['data'];
      if(this.result.length === 0){
        this.noData = true;
      }
      else {
        this.noData = false;
      }
    }, (error) => {
      this.spinnerService.hide();
      this.flashService.show(error.error.message, 'alert-error');
    })
  }

  async searchSkillDetail(departmentId, categoryId, skillId, expertiseId) {
    this.spinnerService.show();
    this.userloading = false;
    this.skillloading = true;
    this.filterData = {
      filter:[{
      "department_id":departmentId ? departmentId : [],
      "category_id":categoryId ? categoryId : [],
      "skill_id":skillId ? skillId : [],
      "expertise_id":expertiseId ? expertiseId : []
    }]
  }
    await this.skillService.getSkillFilter(this.filterData).toPromise().then(data => {
      this.spinnerService.hide();
      this.filterResponse = data['data'];
      this.result = data['data'];
      if(this.result.length === 0){
        this.noData = true;
      }
      else{
        this.noData = false;
      }
    }, (error) => {
      this.spinnerService.hide();
    })
  }

  async getDepartment(departmentId = null, categoryId = null, skillId = null) {
    await this.skillService.getCategorySkillByDepartments()
    .toPromise().then(async (data) => {
        this.departmentList = data;

        this.departmentList.forEach((res, index) => {
          this.departmentList[index].name = res.department_name;
          this.departmentList[index].id = res.department_id;
        })
        // this.adminForm.patchValue({
        //   'department_id': departmentId ? departmentId : -1
        // });

        if (departmentId) {
          await this.getCategoryByDepartmentId(departmentId, categoryId, skillId);
        }
      })
  }

  async getCategoryByDepartmentId(departmentId, categoryId = null, skillId = null) {
    let department = this.departmentList

    //Reseting the filtered values

    for ( let row in department ) {
      if ( department[row].department_id == departmentId ) {
        let selectDepCategories = [];
        selectDepCategories = department[row].category as any;
        /**
           * Here i'm add id and name key in categoryList object bcz we
           * using multiple dropown package thatpackage need to be have id and name in constant
           * so for that add both key in front-end.
        */
       selectDepCategories.forEach((res, index) => {
          selectDepCategories[index].name = res.category_name;
          selectDepCategories[index].id = res.category_id;
        });
        const concatAllselectedCat = !!this.categoryList ? selectDepCategories.concat(this.categoryList) : selectDepCategories;
        // Filtering duplicate array.
        this.categoryList = concatAllselectedCat.filter((set => f => !set.has(f.category_id) && set.add(f.category_id))(new Set));
        // Remove the unselect department categories from selected categories list.
        // this.selectedCategories =  this.selectedCategories &&      this.selectedCategories.length > 0 ?
        //           this.selectedItemUpdation(this.selectedCategories, this.categoryList.map(res => res.category_id)) : this.selectedCategories;
        break;
      }
    }

    if (categoryId) {
      // this.adminForm.patchValue({
      //   'category_id': categoryId
      // });

      // this.getSkillByCategeoryById(categoryId, skillId);
      await this.categoryListnerFilter(categoryId, skillId);
    }
  }

  async getSkillByCategeoryById(categoryId = null, skillId = null) {
    if (categoryId) {
      let category = this.categoryList
      for ( let row in category ){
        if ( category[row].category_id == categoryId ) {
          let selectCatSkillList = [];
          selectCatSkillList = category[row].skill as any;

          /**
           * Here i'm add id and name key in categoryList object bcz we
           * using multiple dropown package thatpackage need to be have id and name in constant
           * so for that add boyh key in front-end.
           */
          selectCatSkillList.forEach((res , index) => {
            selectCatSkillList[index].name = res.skill_name;
            selectCatSkillList[index].id = res.skill_id;
            return;
          });

          const concatAllselectedskill = !!this.skillList ? selectCatSkillList.concat(this.skillList) : selectCatSkillList;
          // Filtering duplicate array.
          this.skillList = concatAllselectedskill.filter((set => f => !set.has(f.skill_id) && set.add(f.skill_id))(new Set));
          this.changeDetector.detectChanges();
        break;
        }
      }
    }

  }

  getUser(departmentId) {
    forkJoin(departmentId.map(res => this.skillService.getUserByDepartment(res))).pipe(
      map(arr => arr.reduce((a1: any, a2: any) => (a1.push(...a2), a1), []))
    ).subscribe((emp: any[]) => {
        this.employee = emp as any;
        let selectedDepEmployee = emp as any;
        selectedDepEmployee.forEach((res, index) => {
          selectedDepEmployee[index].name = res.employee_name;
          selectedDepEmployee[index].id = res.employee_id;
        });

        this.employeeClone = this.employee = selectedDepEmployee;
        this.selectEmployee = !!this.selectEmployee && this.selectEmployee.length > 0 ?
          this.selectedItemUpdation(this.selectEmployee, this.employee.map(res => res.employee_id)) : undefined;
    });
  }

  trackByFn(index) {
    return index;
  }

  /**
   *
   * @param item
   * @param source
   * @description Get active selected item from parent dropdown
   *  then compare by ID and update in the selected item like category, skills dropdown.
   *
   * Add the selected skill id and alllist skill id then finding duplicate id that ID is the selected skill id.
   */
  selectedItemUpdation(item: number[], source: number[]) {
    const sourceItem = item.concat(source);
    return sourceItem.filter((s => v => s.has(v) || !s.add(v))(new Set));
  }

    /**
   * @param depIDs
   * @description Get the allcategory list from selected department once done await forloop
   *  then show selected category.
   */

  async departmentListnerFilter(depIDs : number[]) {
    await depIDs.forEach(async depId => {
      await this.getCategoryByDepartmentId(depId)
    });
    // Remove the unselect department categories from selected categories list.
    this.selectedCategories =  this.selectedCategories &&      this.selectedCategories.length > 0 ?
       this.selectedItemUpdation(this.selectedCategories, this.categoryList.map(res => res.category_id)) : this.selectedCategories;

    !!this.selectedCategories && this.selectedCategories.length == 0 ? this.adminForm.controls.category_drop.reset() : this.adminForm.controls.category_drop.setValue(this.selectedCategories);
    this.changeDetector.detectChanges();

  }

  /**
   *
   * @param catID
   * @param skillID
   * @description Get the skill list from selected category once done await forloop
   *  then show selected skill.
   */
  async categoryListnerFilter(catID: number[], skillID = null) {
    catID.forEach(async depId => {
      await this.getSkillByCategeoryById(depId, skillID );
    });
     // Remove the unselect categories skills from selected list.
     this.selectedSkill = this.selectedSkill && this.selectedSkill.length > 0 ?
     this.selectedItemUpdation(this.selectedSkill, this.skillList.map(res => res.skill_id)) : this.selectedSkill;
     this.changeDetector.detectChanges();
     !!this.selectedSkill && this.selectedSkill.length == 0 ? this.adminForm.controls.skill_drop.reset() : this.adminForm.controls.skill_drop.setValue(this.selectedSkill);
  }

  /**
   * @param depIDs
   * @description Get the employee list from selected department once done await.
   */
  async employeeListnerFilter(empIDs: number[]) {
    this.getUser(empIDs);
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/admin-filter/admin-filter.component.ts